import { CommonModule } from '@angular/common'
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core'
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms'
import { CaseInput } from '../../../interfaces/case-input.interface'

@Component({
    selector: 'case-euros-input',
    templateUrl: './euros-input.component.html',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule]
})
export class EurosInputComponent implements OnChanges, CaseInput {
  @Input() label: string
  @Input() initialValue: number
  @Input() placeholder: string
  @Input() helpText: string
  @Input() showErrors = false
  @Input() validators: ValidatorFn[] = []
  @Input() uniqueId: string

  // Custom number input params.
  @Input() step: string
  @Input() min: number = 0
  @Input() max: number

  @Output() valueChanged: EventEmitter<number> = new EventEmitter()

  numberForm: UntypedFormGroup
  required: boolean

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnChanges(changes: SimpleChanges) {
    // Prevent value from being reset if showErrors changes.
    if (
      Object.keys(changes).length === 1 &&
      Object.keys(changes)[0] === 'showErrors'
    ) {
      return
    }

    this.numberForm = this.formBuilder.group({
      number: [this.initialValue || null, this.validators]
    })
    this.required = this.validators.includes(Validators.required)
  }

  onChange(newValue: string) {
    this.valueChanged.emit(parseFloat(newValue))
  }
}
